import { render } from "./BlankComponent.vue?vue&type=template&id=19cc1668"
import script from "./BlankComponent.vue?vue&type=script&lang=js"
export * from "./BlankComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__